import React, { useEffect, useState } from 'react';
import { customerInfoHandler, fetchData, formatIndianCurrency, handleNavigate, saveLogEvent } from '../../utils/Utils';
import { useNavigate } from 'react-router-dom';

const CustomerDetails = ({ labels, customerInfo }) => {
    const [groupInfo, setGroupInfo] = useState();
    const [selectedCustomers, setSelectedCustomers] = useState([]);
    const [customerNumber, setCustomerNumber] = useState('');
    const navigate = useNavigate();
    const stat = customerInfoHandler(customerInfo);

    const onClickHandler = (route, actionType, gpNumber) => {
        let logPayload = {};

        if (actionType === "groupMember") {
            logPayload = {
                trigger: "Pay to another Member dues, On click of Proceed To Pay", paidCustomerNumber: gpNumber
            };
        } else if (actionType === "wholeGroup" || actionType === "selectedMember") {
            logPayload = {
                trigger: `{Pay for the ${actionType}, On click of Proceed To Pay}`, groupNumber: gpNumber
            };
        }

        saveLogEvent({
            logLevel: "info",
            statusCode: 200,
            status: "success",
            message: { ...logPayload, Page: "Customer Details Page" },
            payload: {
                trigger: logPayload.trigger,
                Page: "Customer Details Page"
            }
        });

        handleNavigate(navigate, route);
    };

    const handleSelectCustomer = (customerNumber) => {
        setSelectedCustomers(prev =>
            prev.includes(customerNumber) ? prev.filter(num => num !== customerNumber) : [...prev, customerNumber]
        );
    };

    useEffect(() => {
        setGroupInfo(customerInfo?.GroupDetails?.Customers?.filter((el => el.Number !== customerInfo?.CustomerDetails.Number)));
        setCustomerNumber(customerInfo?.CustomerDetails?.Number)
    }, [customerInfo])

    if (!customerInfo) {
        return <p className="flex items-center justify-center min-h-screen"> loading</p>
    }

    return (
        <>
            <div className=" font-bold mt-2 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-lg fs-32w">
                {labels.payForGroupMember}
            </div>
            <div className="flex-grow sm:h-[71vh] md:h-[69vh] lg:h-[67vh] xl:h-[64vh] my-1 overflow-y-auto fs-30w">
                {
                    groupInfo?.map((el, ind) => (
                        <div key={ind} className={`${el.LoanHealth === "Overdue" ? 'bg-red-500 text-[white]' : 'bg-green-200 text-black'} p-4 rounded-tl-lg rounded-tr-lg rounded-b-lg mt-6`}>
                            <div className="grid grid-cols-2 gap-2">
                                <div>{labels.customerName}</div>
                                <div className="text-end">{el.Name}</div>
                                <div>{labels.customerNumber}</div>
                                <div className="justify-self-end">{el.Number}</div>
                                <div>{labels.paymentType}</div>
                                <div className="justify-self-end">{el.LoanHealth === "Overdue" ? "Overdue" : "Installment"}</div>
                                <div>{el.LoanHealth === "Overdue" ? labels.amountOverdue : labels.amountDue}</div>
                                <div className="justify-self-end">{el.LoanHealth === "Overdue" ? formatIndianCurrency(el.OverdueAmount) : formatIndianCurrency(el.NextInstalmentDetails?.AmountDue)}</div>
                            </div>
                            <div className="flex justify-center mt-2">
                            </div>
                            <div className="flex justify-around items-center">
                                <input
                                    type="checkbox"
                                    checked={selectedCustomers.includes(el.Number)}
                                    onChange={() => handleSelectCustomer(el.Number)}
                                />
                                <button onClick={() => { onClickHandler(`/payment/${el.Number}`, "groupMember", el.Number) }} className="mt-4 bg-white text-green-800 px-4 py-2 rounded-lg">{labels.proceedToPay}</button>
                            </div>
                        </div>
                    ))
                }
            </div>
            {selectedCustomers.length > 0 && <button
                onClick={() => onClickHandler(
                    `/multiplePayment/${customerNumber}/${selectedCustomers.join(',')}`,
                    "selectedMember",
                    selectedCustomers
                )}
                className="bg-[#fdba14] text-white p-3 py-2 rounded-lg w-[100%]"
            >
                {labels.proceedToPay}
            </button>}
            <div className="font-bold mt-8 text-black text-lg border-t border-r border-l bg-gray-300 p-3 rounded-lg fs-32w">
                {labels.PayForAWholeGroup}
            </div>
            <div className="flex-grow sm:h-[71vh] md:h-[69vh] lg:h-[67vh] xl:h-[64vh]   overflow-y-auto fs-30w">
                <div className={`bg-green-200 text-black p-4 rounded-tl-lg rounded-tr-lg rounded-b-lg mt-6`}>
                    <div className="grid grid-cols-2 gap-2">
                        <div>{labels.GroupName}</div>
                        <div className="text-end">{stat.groupName}</div>
                        <div>{labels.GroupId}</div>
                        <div className="justify-self-end">{stat.groupNumber}</div>
                        <div>{labels.paymentType}</div>
                        <div className="justify-self-end">Installment</div>
                        <div>{labels.amountDue}</div>
                        <div className="justify-self-end">{formatIndianCurrency(stat.totalDueAmount)}</div>
                    </div>
                    <div className="flex justify-center mt-2"></div>
                    <div className="flex justify-center">
                        <button onClick={() => { onClickHandler(`/payment/${customerNumber}/${stat.groupNumber}`, "wholeGroup", stat.groupNumber) }} className="mt-4 bg-white text-green-800 px-4 py-2 rounded-lg">{labels.proceedToPay}</button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CustomerDetails;
